// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2PNEA","col":"styles_col__OrNOM"};